<template>
  <div class="login">
    <el-container>
      <el-header style="margin-top: 20px; height: 20px; color: #ffffff"
        >食堂预约系统
        <el-dropdown style="float: right">
          <el-button type="primary" size="mini">
            设置<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="accountEdit"
              >修改账号</el-dropdown-item
            >
            <el-dropdown-item @click.native="passwordEdit"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item @click.native="exit">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button type="primary" size="mini" style="float:right" @click="accountEdit" >修改账号</el-button> -->
      </el-header>
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>当前日期：{{ nowDate }}</span>
            <el-radio-group v-model="timeInterval" style="margin-top:10px" @change="getUserReservationByTimeInterval">
              <el-radio-button label="中餐">预约中餐</el-radio-button>
              <el-radio-button label="晚餐">预约晚餐</el-radio-button>
            </el-radio-group>
          </div>
            
          <div class="calendardome">
            <!-- <h5>原作者版本(加了滑动切换)</h5>
      <h5-calendar lunar :touchthreshold="50"/> -->
            <calendar
              ref="calendar"
              :multi="calendar5.multi"
              :touchthreshold="50"
              :range="calendar5.range"
              :lunar="calendar5.lunar"
              :value="calendar5.value"
              :begin="calendar5.begin"
              :end="calendar5.end"
              :disabled="calendar5.disabled"
              :checkMonth="calendar5.checkMonth"
              @select="calendar5.select"
            ></calendar>
          </div>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">
            <span>当前时段预约：{{ userReservation.length }}</span>
          </div>
          <div
            v-for="(resevation, i) in userReservation"
            :key="i"
            class="text item"
            style="padding: 8px 0"
          >
            {{ resevation.date }}
            {{ resevation.timeInterval }}
          </div>
        </el-card>
        <!-- <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">
            <span>剩余预约名额</span>
          </div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="日期" width="100">
            </el-table-column>
            <el-table-column prop="breakfast" label="早餐"> </el-table-column>
            <el-table-column prop="count" label="中餐"> </el-table-column>
            <el-table-column prop="dinner" label="晚餐"> </el-table-column>
          </el-table>
        </el-card> -->
      </el-main>
    </el-container>
  </div>
</template>

<script>
// 局部引入
import $ from "jquery";
// import H5Calendar from "vue-calendar-h5";
import calendar from "./Component/Calendar/calendar.vue";
export default {
  name: "App",
  components: { calendar },
  data() {
    return {
      nowDate: "",
      calendar5: {
        // display:"2017/11/2,2017/12/2",
        multi: true,
        // show:false,
        zero: true,
        begin: [], //可选开始日期
        end: [], //可选结束日期
        value: [], //默认日期
        disabled: [],
        lunar: true, //显示农历
        // events:{},
        select: (value) => {
          this.calendarSelect(value, this.calendar5.oldValue);
        },
        oldValue: [],
        checkMonth: { month: 0, flag: false },
      },
      // 表格数据
      tableData: [],
      userToken: "",
      userReservation: [],
      timeInterval:"中餐"
    };
  },

  created: function () {
    this.userToken = window.sessionStorage.getItem("userToken");
    if (!this.userToken) {
      this.$router.push("/login");
      return;
    }
    var aDate = new Date();
    var endDate = new Date();
    endDate.setDate(endDate.getDate() + 15);
    this.calendar5.begin = [
      aDate.getFullYear(),
      aDate.getMonth() + 1,
      aDate.getDate() + 1,
    ];
    this.calendar5.end = [
      endDate.getFullYear(),
      endDate.getMonth() + 1,
      endDate.getDate(),
    ];

    this.nowDate =
      aDate.getFullYear() +
      "-" +
      (aDate.getMonth() + 1) +
      "-" +
      aDate.getDate();
    this.tableData = [];
    this.getUserReservation();
    this.getCloseDownDate();
    // this.getRemainReservation();
  },
  mounted() {
    var that = this;
    // setInterval(function () {
    //   that.getRemainReservation();
    // }, 5000);
  },
  methods: {
    getUserReservationByTimeInterval(){
      this.getUserReservation();
    },
    getUserReservation(date1) {
      var that = this;
      this.axios
        .post("/Canteen/GetUserReservation", { userToken: this.userToken,timeInterval:this.timeInterval })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              that.userReservation = response.data.data;
              that.calendar5.value = [];
              that.calendar5.oldValue = [];
              response.data.data.forEach((d) => {
                var date = d.date.split("-");
                that.calendar5.value.push([
                  parseInt(date[0]),
                  parseInt(date[1]),
                  parseInt(date[2]),
                ]);
                that.calendar5.oldValue.push([
                  parseInt(date[0]),
                  parseInt(date[1]),
                  parseInt(date[2]),
                ]);
              });
              console.log(date1);
              if (date1) {
                that.calendar5.checkMonth.flag =
                  !that.calendar5.checkMonth.flag;
                that.calendar5.checkMonth.month = parseInt(date1.split("-")[1]);
              }
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
        });
    },
    addCanteenReservation(date) {
      console.log(date);
      const loading = this.$loading();
      var that = this;
      this.axios
        .post("/Canteen/AddCanteenReservation", {
          userToken: this.userToken,
          date: date,
          timeInterval:this.timeInterval
        })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              that.$message.success("预约/取消预约成功！");
              that.getUserReservation(date);
            } else {
              that.$message.error(response.data.message);
              that.getUserReservation();
            }
          } else {
            that.$message.error("请检查网络设置");
          }
          loading.close();
        });
    },
    calendarSelect(value, oldValue) {
      var result = [];
      for (var i = 0; i < value.length; i++) {
        var obj = value[i];
        var num = obj[0] + obj[1] + obj[2];
        var isExist = false;
        for (var j = 0; j < oldValue.length; j++) {
          var aj = oldValue[j];
          var n = aj[0] + aj[1] + aj[2];
          if (n == num) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          result.push(obj);
        }
      }
      if (result.length > 0) {
        var month = result[0][1];
        if (parseInt(month) < 10) {
          month = "0" + month;
        }
        var day = result[0][2];
        if (parseInt(day) < 10) {
          day = "0" + day;
        }
        this.addCanteenReservation(result[0][0] + "-" + month + "-" + day);
        return;
      }

      result = [];
      for (var i = 0; i < oldValue.length; i++) {
        var obj = oldValue[i];
        var num = obj[0] + obj[1] + obj[2];
        var isExist = false;
        for (var j = 0; j < value.length; j++) {
          var aj = value[j];
          var n = aj[0] + aj[1] + aj[2];
          if (n == num) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          result.push(obj);
        }
      }
      if (result.length > 0) {
        var month = result[0][1];

        if (parseInt(month) < 10) {
          month = "0" + month;
        }
        var day = result[0][2];
        if (parseInt(day) < 10) {
          day = "0" + day;
        }
        this.addCanteenReservation(result[0][0] + "-" + month + "-" + day);
        return;
      }
    },
    getCloseDownDate() {
      var that = this;
      this.axios
        .post("/Canteen/GetCloseDownDate", {})
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              that.calendar5.disabled = [];
              response.data.data.forEach((d) => {
                var date = d.date.split("-");
                that.calendar5.disabled.push([
                  parseInt(date[0]),
                  parseInt(date[1]),
                  parseInt(date[2]),
                ]);
              });
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
        });
    },
    getRemainReservation() {
      var that = this;
      this.axios
        .post("/Canteen/GetRemainReservation", {})
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              that.tableData = response.data.data;
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
        });
    },
    accountEdit() {
      this.$router.push("/AccountEdit");
    },
    passwordEdit() {
      this.$router.push("/PasswordEdit");
    },
    exit() {
      window.sessionStorage.removeItem("userToken");
      this.$router.push("/Login");
    },
  },
};
</script>
<style scoped>
.login {
  width: 100%;
  height: 100%;
  background: url(../assets/bg.png) no-repeat;
  background-size: cover;

  z-index: -10;
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue